"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.search");
var _GoodsPromotionTablePane = _interopRequireDefault(require("./GoodsPromotionTablePane"));
var _GoodsPromotionCfgPane = _interopRequireDefault(require("./GoodsPromotionCfgPane.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'goods_promotion',
  components: {
    GoodsPromotionCfgPane: _GoodsPromotionCfgPane.default,
    GoodsPromotionTablePane: _GoodsPromotionTablePane.default
  },
  data: function data() {
    return {
      activeName: 'all',
      goodsList: [],
      editFnId: ''
    };
  },
  created: function created() {},
  methods: {
    handleToConfig: function handleToConfig(goodsList) {
      // 批量设置
      this.activeName = 'config';
      this.goodsList = goodsList || [];
      this.editFnId = '';
    },
    handleToEditConfig: function handleToEditConfig(goods) {
      // 单个编辑
      this.activeName = 'config';
      this.goodsList = [goods] || [];
      this.editFnId = goods.goodsPromotionFnId;
    },
    handleSuccess: function handleSuccess() {
      this.activeName = 'all';
      this.$refs.goodsPromotionAll.search();
    }
  }
};